/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import autoBind from 'react-autobind'
import { injectIntl } from 'react-intl'

import { TimePicker as MaterialTime, IconButton } from 'material-ui'
import { grey500, grey800, red500 } from 'material-ui/styles/colors'
import ClearIcon from 'material-ui/svg-icons/navigation/cancel'

import { isDisabled } from './fields'
import * as constants from './constants'

class TimePicker extends React.Component {
  constructor (props) {
    super(props)
    autoBind(this)
  }
  /*
   * Material-ui doesn't provide an event object for DatePicker (always equals to null)
   * https://github.com/callemall/material-ui/issues/441
   * The two following method provide a mock of the event object to the onChange callback
   * so it can get the field name the same way as TextField for example
  */
  handleClear (e) {
    if (!isDisabled(this.props.meta) && !this.props.disabled) {
      this.props.onChange({target: {name: this.props.name}}, null)
    }
  }

  setField (field) {
    this.props.getField(field)
  }

  setFloatingLabelText (floatingLabelText, meta) {
    if (floatingLabelText && meta && meta.mandatory) {
      return [floatingLabelText, <span key={0} style={{color: red500, fontSize:20, verticalAlign:'sub'}}> *</span>]
    }

    return floatingLabelText
  }

  handleChange (event, value) {
    if (this.props.onChange) {
      this.props.onChange({target: {name: this.props.name}}, value)
    }
  }

  render () {
    const { floatingLabelText, meta, value, onChange, intl, getField, divStyle, placeholderMandatory, ...rest } = this.props
    const componentProps = {
      disabled: isDisabled(meta),
      floatingLabelText: this.setFloatingLabelText(floatingLabelText, meta),
      ...rest
    }

    const disabled = componentProps.disabled

    return (
      <div
        style={
          divStyle
            ? divStyle
            : {height: 72, position: 'relative'}
        }
      >
        <MaterialTime
          floatingLabelFixed
          ref={this.setField}
          format="24hr"
          minutesStep={5}
          inputStyle={disabled ? {color: grey800} : null}
          className='timepicker'
          onChange={this.handleChange}
          fullWidth
          errorStyle={{fontSize:10}}
          placeholder={
            placeholderMandatory
              ? this.props.intl.formatMessage(constants.messages.MESSAGE_MANDATORY)
              : this.props.placeholder
          }
          {
          ...componentProps
          }
          value={value ? value.toDate() : undefined}
          cancelLabel={this.props.intl.formatMessage(constants.messages.CANCEL_LABEL)}
          okLabel={this.props.intl.formatMessage(constants.messages.OK_LABEL)}
        />
        {
          value && !isDisabled(this.props.meta) && !this.props.disabled
            ? <IconButton
              style={{position: 'absolute', right: 0, bottom: 0}}
              iconStyle={{width: 20, height: 20}}
              onClick={this.handleClear}
            >
              <ClearIcon color={ grey500 } />
            </IconButton>
            : null
        }
        {
          meta &&
          meta.mandatory &&
          !placeholderMandatory &&
          !value &&
          !this.props.errorText
            ? <p className={'error-message'} style={{margin: 0}}>
              {this.props.intl.formatMessage(constants.messages.MESSAGE_MANDATORY)}
            </p>
            : null
        }
      </div>
    )
  }
}

export default injectIntl(TimePicker)



// WEBPACK FOOTER //
// ./src/generic/form/TimePicker.js